<div class="overview">
    <!-- Main Page Start -->
    <div class="container">
        <div class=" skillsWrap">
            <div class="leftside">
                <ul class="tablist" id="navbar">
                    <li><a href="javascript:void(0)" class="nav-link scrollto active" (click)="scrollToElement(first)">
                            <span>Basic Information</span></a></li>
                    <li><a href="javascript:void(0)" class="nav-link scrollto"
                            (click)="scrollToElement(veteran)"><span>Veteran Experience</span></a></li>
                    <li><a href="javascript:void(0)" class="nav-link scrollto" (click)="scrollToElement(skill)">
                            <span>Skills</span></a></li>
                    <li><a href="javascript:void(0)" class="nav-link scrollto" (click)="scrollToElement(education)">
                            <span>Education</span></a></li>
                    <li><a href="javascript:void(0)" class="nav-link scrollto" (click)="scrollToElement(work)">
                            <span>Work experience</span></a></li>
                    <li><a href="javascript:void(0)" class="nav-link scrollto" (click)="scrollToElement(volunteer)">
                            <span>Volunteer experience</span></a></li>
                    <li><a href="javascript:void(0)" class="nav-link scrollto" (click)="scrollToElement(project)">
                            <span>Projects undertaken</span></a></li>
                    <li><a href="javascript:void(0)" class="nav-link scrollto" (click)="scrollToElement(award)">
                            <span>Awards & honors</span></a></li>
                    <li><a href="javascript:void(0)" class="nav-link scrollto" (click)="scrollToElement(lic)">
                            <span>Licenses & certifications</span></a></li>
                    <li><a href="javascript:void(0)" class="nav-link scrollto" (click)="scrollToElement(lang)">
                            <span>Languages</span></a></li>
                    <li><a href="javascript:void(0)" class="nav-link scrollto" (click)="scrollToElement(job)"> <span>Job
                                preferences</span></a></li>
                </ul>
            </div>
            <div class="rightside editProfile">
                <div id="basic" #first>
                    <div class="whiteBox">
                        <div class="whiteboxinner">
                            <div class="profileupload ">
                                <div class="avatar-preview">
                                    <div id="imagePreview" class="userImage">
                                        <img [src]="profileImage != null ? globalUrl + profileImage : '../../../assets/images/profile-img.jpg'">

                                    </div>
                                </div>
                                <div class="pofiledetailinner">
                                    <h5 class="name">{{userData?.name}} </h5>
                                    <p class="location"><img src="assets/images/ic_location.svg" class="ht m-0"
                                            alt="location">
                                        <span>{{userData?.location}}</span>
                                    </p>
                                    
                                    
                                    <div class="badge"><img src="assets/images/ic_badge.svg" alt="badge">
                                        <p class="orange">{{userData?.Services != null ? userData?.Services : "-"}}</p>
                                    </div>

                                </div>
                            </div>

                            <div class="profileadd">
                                <a href="javascript:void(0);" (click)="openModal(resume)" class="orangeBtn pd me-3">
                                    <img src="assets/images/ic_download.svg" class="me-1" alt="download">Download
                                    Resume</a>
                                <a href="javascript:void(0);" routerLink="/profile/edit" class="addMoreBtn pd"> <span
                                        class="pluseIcon"><img src="assets/images/ic_edit.svg"> </span> Edit Profile
                                </a>

                            </div>
                        </div>
                        <p class="para4" style="overflow: hidden;">{{userData?.bio}}</p>


                    </div>

                    <!-- 2 -->

                    <div class="whiteBox">
                        <div class="basicbox">
                            <div class="basicinfo">
                                <p class="subheading-2"> <strong>Basic Information</strong>

                                </p>
                                <div class="row basicdetails">
                                    <div class="col-sm-6 col-lg-4 col-md-6  col-sm-12">
                                        <h6 class="heading-16 mt-2">Phone</h6>
                                        <p class="para-16">{{userData?.countryCode}} {{userData?.phoneNumber || "--"}}
                                        </p>
                                    </div>
                                    <div class="col-sm-6 col-lg-4 col-md-6  col-sm-12">
                                        <h6 class="heading-16 mt-2">Pronouns Type</h6>
                                        <p class="para-16">{{(userData?.pronounsType ==="Add Custom" || userData?.pronounsType ==="Add custom") ? (userData?.customPronouns ? userData?.customPronouns:'') :userData?.pronounsType}}
                                        </p>
                                    </div>
                                    <div class="col-sm-6 col-lg-4 col-md-6  col-sm-12">
                                        <h6 class="heading-16 mt-2">Gender</h6>
                                        <p class="para-16">{{userData?.gender==0?'Male':(userData?.gender==1?'Female':(userData?.gender==2?'Non-binary':'--'))}}
                                        </p>
                                    </div>

                                   
                                    <div class="col-sm-6 col-lg-4 col-md-6 col-sm-12 ">
                                        <h6 class="heading-16 mt-2">Email</h6>
                                        <p class="para-16 noCap firstlCaptial">{{userData?.email}}</p>

                                    </div>
                                    <div class="col-sm-6 col-lg-4 col-md-6 col-sm-12 ">
                                        <h6 class="heading-16 mt-2">Profile last visited</h6>
                                        <p class="para-16">{{userData?.createdAt | date}}</p>

                                    </div>
                                    <div class="col-sm-12 col-lg-12 col-md-12 pt-2">
                                        <p class="heading-16 mt-2">16 personalities score link</p>
                                        <p hidden> <a class="blue">www.16personalities.com/istp-personality</a></p>
                                        <p><a class="blue" [href]="userData?.scoreLink"
                                                target="_blank">{{userData?.scoreLink}}</a></p>
                                    </div>


                                </div>
                            </div>

                        </div>

                    </div>

                </div>

                <!-- 3 -->
                <div class="whiteBox" id="veteran" #veteran>
                    <div class="basicbox">
                        <div class="basicbox">
                            <div class="basicinfo">
                                <p class="subheading-2">Veteran Experience
                                    <a href="javascript:void(0);" (click)="opneVeteranModel(userData,addVeteran)"
                                        title="Edit"><img src="../../../assets/images/ic_edit.svg" class="ht"> </a>
                                </p>
                                <div class="row basicdetails">
                                    <div class="col-sm-12 col-lg-4 col-md-6">
                                        <h6 class="heading-16 mt-2">Military branch served</h6>
                                        <p class="para-16">{{userData?.Services != null ? userData?.Services : "-"}}</p>

                                    </div>
                                    <div class="col-sm-12 col-lg-4 col-md-6">
                                        <h6 class="heading-16 mt-2">Military job title</h6>
                                        <p class="para-16">{{userData?.militaryJobTitle != null ?
                                            userData?.militaryJobTitle : "-"}}</p>

                                    </div>

                                    <div class="col-sm-12 col-lg-4 col-md-6"
                                        *ngIf="userData?.otherServiceTitle != null">
                                        <h6 class="heading-16 mt-2">Other Service Title</h6>
                                        <p class="para-16">{{userData?.otherServiceTitle != null ?
                                            userData?.otherServiceTitle : "-"}}</p>

                                    </div>
                                    <div class="col-sm-12 col-lg-4 col-md-6"
                                        *ngIf="userData?.authenticityDocumentLink != null">
                                        <h6 class="heading-16 mt-2">Document</h6>
                                        <p class="para-16"><a [href]="globalUrl+userData?.authenticityDocumentLink"
                                                target="_blank"><img src="../../../assets/images/ic_document.svg"
                                                    class="ht m-0">{{userData?.authenticityDocumentLink != null ?
                                                userData?.authenticityDocumentLink : "-"}}</a></p>

                                    </div>
                                    <div class="col-sm-12 col-lg-4 col-md-6">
                                        <h6 class="heading-16 mt-2">Veteran Relation Type </h6>
                                        <p class="para-16">
                                            <span *ngIf="userData?.veteranRelationType == 0">Veteran</span>
                                            <span *ngIf="userData?.veteranRelationType == 1">Spouse</span>
                                            <span *ngIf="userData?.veteranRelationType == 2">Child</span>
                                            <span *ngIf="userData?.veteranRelationType == 3">Parents</span>
                                        </p>
                                    </div>
                                    <div class="col-sm-12 col-lg-4 col-md-6" *ngIf="userData?.veteranRelationName">
                                        <h6 class="heading-16 mt-2">Veteran Relation Name </h6>
                                        <p class="para-16">{{userData?.veteranRelationName != null ?
                                            userData?.veteranRelationName : "-"}}</p>
                                    </div>
                                    <div class="col-sm-12 col-lg-4 col-md-6"
                                        *ngIf="userData?.veteranRelationDocumentLink">
                                        <h6 class="heading-16 mt-2">Veteran Relation Document
                                        </h6>
                                        <p class="para-16"><img src="../../../assets/images/ic_document.svg"
                                                class="ht m-0"
                                                *ngIf="userData?.veteranRelationDocumentLink">{{userData?.veteranRelationDocumentLink
                                            != null ?
                                            userData?.veteranRelationDocumentLink : "-"}}</p>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <!-- 4 -->



                <div class="whiteBox" id="skill" #skill>
                    <div class="basicbox">
                        <div class="basicbox">
                            <div class="basicinfo">
                                <div class="basicdetails-inner">
                                    <p class="subheading-2">Skills
                                        <a href="javascript:void(0);" (click)="opneEditSkillModel(addSkill)"
                                            title="Edit"><img src="assets/images/ic_edit.svg" class="ht"> </a>
                                    </p>

                                    <div class="profileadd">
                                        <a (click)="opneSkillModel(addSkill)" class="addMoreBtn"> <i
                                                class="pluseIcon"><img src="assets/images/ic_plus.svg"> </i> Add More
                                        </a>

                                    </div>
                                </div>
                                <div class="col-lg-12  basicdetails">

                                    <ul class="addedskills">
                                        <li *ngFor="let skil of resumeData?.skills; let i =index;">
                                            {{skil?.skillDetails?.name}} </li>
                                    </ul>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <!-- Education -->
                <div class="whiteBox" id="education" #education>

                    <h4 class="pageTitle"><span class="subheading-2"><strong>Education </strong> </span> <a
                            (click)="openEduModal(addMoreEdu)" class="addMoreBtn"> <i class="pluseIcon"><img
                                    src="assets/images/ic_plus.svg"> </i> Add More </a></h4>

                    <div class="education_added">
                        <ul class="timeline">
                            <li *ngFor="let edu of resumeData?.educations; let i =index;">
                                <span class="timeline-point-circle fill"></span>
                                <div class="el_details">
                                    <p> <strong> {{edu?.specializationDetails?.name}} </strong>
                                        <a (click)="editEdu(addMoreEdu,edu)" title="Edit"><img
                                                src="assets/images/ic_edit.svg" class="ht"> </a>
                                    </p>
                                    <span>{{edu?.universityDetails?.name}} </span>
                                </div>
                                <div class="el_details">
                                    <p><strong class="space">GPA : </strong>{{edu.gpa == null || edu.gpa == "" ? " -" :
                                        " " +edu.gpa + " GPA"}}</p>
                                    <p><strong class="space"> Duration : </strong> {{edu.fromDate | date}} -
                                        {{edu.toDate != null ?
                                        (edu.toDate | date) :"Currently Pursuing"}} </p>
                                </div>

                            </li>
                        </ul>
                    </div>
                </div>
                <!-- work -->

                <div class="whiteBox" id="work" #work>
                    <h4 class="pageTitle"><span class="subheading-2">Work Experience</span><a href="javascript:void(0);"
                            (click)="openWorkModal(addMoreWork)" class="addMoreBtn"> <i class="pluseIcon"><img
                                    src="assets/images/ic_plus.svg"> </i> Add More </a></h4>

                    <div class="col-lg-12 education_added p-0"
                        *ngFor="let work of resumeData?.workExperiences; let i =index">
                        <div class="work-des mb-3">
                            <p> <strong class="firstlCaptial">{{work.companyName || "-"}}</strong> <span class="time">
                                    {{work?.employementTypeDetails?.name || "-"}}</span>
                                <a href="javascript:void(0);" (click)="editWork(work,addMoreWork)" title="Edit"><img
                                        src="assets/images/ic_edit.svg" class="ht"> </a>
                            </p>
                            <p class="exp para3" *ngIf="work?.isCurrentlyRole == 0">
                                {{dateAgo(work?.fromDate,work?.toDate)}}</p>
                            <p class="exp para3" *ngIf="work?.isCurrentlyRole == 1">Currently Working</p>
                        </div>
                        <ul class="timeline">
                            <li>
                                <span class="timeline-point-circle fill"></span>
                                <div class="el_details">
                                    <p> <strong class="firstlCaptial">{{work.jobTitle || "-"}}</strong>

                                    </p>
                                    <span> {{work?.fromDate ? (work?.fromDate | date) : "Currently Working" }} -
                                        {{work?.toDate ?
                                        (work?.toDate | date) : "Currently Working"}}</span>
                                </div>
                                <div class="row">
                                    <div class="col-12">
                                        <div class="expinner">
                                            <h6 class="companyname">
                                                <div class="firstlCaptial"> {{work.companyName}}</div> <span
                                                    class="time">{{work?.employementTypeDetails?.name}}</span>
                                            </h6>
                                            <p class="designation"><span class="firstlCaptial">{{work.jobTitle}}</span>
                                            </p>
                                            <p class="date">{{work?.fromDate ? (work?.fromDate | date) : "Currently
                                                Working" }} - {{work?.toDate ?
                                                (work?.toDate | date) : "Currently Working"}} </p>
                                            <p class="place">{{work.location}}</p>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>

                </div>
                <!-- end -->
                <div class="whiteBox" id="volunteer" #volunteer>
                    <h4 class="pageTitle"><span class="subheading-2">Volunteer Experience</span> <a
                            (click)="openVolModal(addMoreVol)" class="addMoreBtn"> <i class="pluseIcon"><img
                                    src="assets/images/ic_plus.svg"> </i> Add More
                        </a></h4>
                    <div class="education_added">
                        <ul class="timeline">
                            <li *ngFor="let vol of resumeData?.volunteerExperiences;let i=index">
                                <span class="timeline-point-circle fill"></span>
                                <div class="el_details">
                                    <p> <strong class="firstlCaptial">{{vol.organization}}</strong>
                                        <a href="javascript:void(0);" (click)="editVol(addMoreVol,vol)"
                                            title="Edit"><img src="assets/images/ic_edit.svg" class="ht"> </a>
                                    </p>
                                    <p class="para3"> {{vol.role}} </p>

                                    <ul class="mt-4">
                                        <li><span class="ft-wt"> Duration : </span> {{vol.fromDate |date}} {{vol.toDate
                                            |date}}</li>

                                        <li><span class="ft-wt">Description : </span> {{vol.description}}</li>
                                    </ul>

                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="whiteBox" id="project" #project>
                    <h4 class="pageTitle"><span class="subheading-2"><strong>Project Undertaken</strong> </span> <a
                            (click)="openProjectModal(addMoreProjects)" class="addMoreBtn"> <i class="pluseIcon"><img
                                    src="assets/images/ic_plus.svg"> </i> Add More </a></h4>
                    <div class="education_added">
                        <ul class="timeline">
                            <li *ngFor="let project of resumeData?.projects; let j =index;">
                                <span class="timeline-point-circle fill"></span>
                                <div class="el_details">
                                    <p> <strong class="firstlCaptial">{{project.projectTitle}}</strong>
                                        <a href="javascript:void(0);" (click)="editProject(project,addMoreProjects)"
                                            title="Edit"><img src="assets/images/ic_edit.svg" class="ht"> </a>
                                    </p>
                                    <p class="para3">{{project.associatedWith}} </p>
                                    <ul class="mt-4">
                                        <li><span class="ft-wt"> Duration : </span> {{project.fromDate | date}} -
                                            {{project.toDate | date}}</li>

                                        <li><span class="ft-wt">Project description : </span> {{project.description}}
                                        </li>
                                    </ul>
                                </div>
                                <div class="el_details">
                                    <p class="ft-wt"
                                        *ngIf="project.projectTeamMembersDetails != null && project.projectTeamMembersDetails != ''">
                                        Team member</p>
                                    <table class="detailstable">
                                        <tr *ngFor="let mem of project.projectTeamMembersDetails; let i =index">
                                            <td class="col-6">{{mem.name}}</td>
                                            <td class="col-6">{{mem.email}}</td>
                                        </tr>
                                    </table>
                                    <div class="form-group">
                                        <p class="ft-wt pt-2">Media</p>
                                        <ul class="medias">
                                            <li *ngFor="let thumb of _albums[j]; let i =index"><span
                                                    class="thumbnailIcon">
                                                    <img [src]="thumb.src" (click)="open(i)" />
                                                </span></li>
                                        </ul>
                                    </div>
                                    <ul class="pt-2">
                                        <li><span class="ft-wt">Links</span></li>
                                        <li *ngFor="let link of project.projectLinksDetails; let i =index"
                                            class="noAfter">
                                            <a [href]="link.link" target="_blank" class="blue-text">{{link.link}}</a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- awards -->

                <div class="whiteBox" id="award" #award>

                    <h4 class="pageTitle"><span class="subheading-2">Awards </span> <a
                            (click)="openAwardModal(addMoreAward)" class="addMoreBtn"> <i class="pluseIcon"><img
                                    src="assets/images/ic_plus.svg"> </i> Add More </a></h4>
                    <div class="education_added">
                        <ul class="timeline">
                            <li *ngFor="let award of resumeData?.awardsAndHonors; let i =index">
                                <div *ngIf="award.isType == 1">
                                    <span class="timeline-point-circle fill"></span>
                                    <div class="el_details">
                                        <p> <strong class="firstlCaptial"> {{award.name}} </strong>
                                            <a href="javascript:void(0);" (click)="editAward(addMoreAward,award)"
                                                title="Edit"><img src="assets/images/ic_edit.svg" class="ht"> </a>
                                        </p>
                                        <span> {{award.associatedWith}}</span>
                                    </div>
                                    <div class="el_details">
                                        <ul>
                                            <li><span class="ft-wt"> Duration : </span> {{award.issuesedOn | date}}
                                            </li>
                                            <li><span class="ft-wt"> Project description : </span> {{award.description}}
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>






                </div>
                <!-- end -->
                <!-- licen -->

                <div class="whiteBox" id="lic" #lic>
                    <h4 class="pageTitle "><span class="subheading-2">Licenses & Certifications</span> <a
                            (click)="openLicModel(addMoreLic)" class="addMoreBtn"> <i class="pluseIcon"><img
                                    src="assets/images/ic_plus.svg"> </i> Add More </a></h4>
                    <div class="education_added">
                        <ul class="timeline">
                            <li *ngFor="let lic of resumeData?.licenseAndCeritifcations; let i =index">
                                <span class="timeline-point-circle fill"></span>
                                <div class="el_details">
                                    <p> <strong class="firstlCaptial"> {{lic.name}}</strong> <a
                                            href="javascript:void(0);" (click)="editLic(lic,addMoreLic)"
                                            title="Edit"><img src="assets/images/ic_edit.svg" class="ht"> </a>
                                    </p>
                                    <span>{{lic.attestedByAuthority}}</span>
                                </div>
                                <div class="el_details">
                                    <ul>
                                        <li><span class="ft-wt"> Issued on : </span> {{lic.issuesedOn | date}} -
                                            {{lic.expirydate != null ? (lic.expirydate | date) : "(No expiration)"}}
                                        </li>
                                        <li><span class="ft-wt">Certificate Id : </span> {{lic.certificationNo}}</li>
                                        <li *ngIf="lic.description != null"><span class="ft-wt">Description
                                                :</span>{{lic.description}}</li>
                                    </ul>
                                    <ul class="pt-2" *ngIf="lic.credentialUrl">
                                        <li><span class="ft-wt">Certified URL</span>
                                            <a href="{{lic.credentialUrl}}" target="_blank"
                                                class="blue-text">{{lic.credentialUrl}}</a>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- end -->
                <!--5 lang  -->

                <div class="whiteBox" id="lang" #lang>
                    <div class="basicbox">
                        <div class="basicbox">
                            <div class="basicinfo">
                                <div class="basicdetails-inner">
                                    <p class="subheading-2"> Languages
                                    </p>

                                    <div class="profileadd">
                                        <a (click)="openLangModel(addMoreLang,resumeData)" class="addMoreBtn"> <i
                                                class="pluseIcon"><img src="assets/images/ic_plus.svg"> </i> Add More
                                        </a>

                                    </div>
                                </div>
                                <div class="row basicdetails ">
                                    <ul class="addedskills">
                                        <li *ngFor="let lang of resumeData?.languages; let i =index">
                                            <strong class="cap">{{lang.language}}</strong> (
                                            <span *ngIf="lang.proficiency =='WriteRead'">Write and Read</span>
                                            <span *ngIf="lang.proficiency =='Read'">Read</span>
                                            <span *ngIf="lang.proficiency =='Speak'">Speak</span>
                                            <span *ngIf="lang.proficiency =='NativeBilingual'">Native Bilingual</span>
                                            )

                                            <span (click)="editLang(addMoreLang, lang)" title="Edit"><img
                                                    src="assets/images/ic_edit.svg" class="ht"> </span>
                                        </li>

                                    </ul>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>


                <!-- 6 -->

                <div class="whiteBox jobpref" id="job" #job>

                    <div class="basicbox">
                        <div class="basicinfo">
                            <div>

                                <p class="subheading-2">Job Preferences

                                    <a href="javascript:void(0);" (click)="openJobModal(allJobs,jobPref)"
                                        title="Edit"><img src="assets/images/ic_edit.svg" class="ht"> </a>
                                </p>
                                <div class="row basicdetails">
                                    <div class="col-lg-4 col-md-6 sol-sm-12 pd">
                                        <h6 class="heading-16">Industry</h6>
                                        <p class="para-16" *ngIf="allJobPreference?.jobPreferenceIndustriesDetails
                        != null"><span class="para-16 industryName" *ngFor="let indus of allJobPreference?.jobPreferenceIndustriesDetails
                        ;let i=index;">{{indus.industryDetails?.name}}</span> </p>
                                        <p class="para-16" *ngIf="allJobPreference?.jobPreferenceIndustriesDetails
                        == null">-</p>

                                    </div>


                                    <div class="col-lg-4 col-md-6 sol-sm-12 pd">
                                        <h6 class="heading-16">Category</h6>
                                        <p class="para-16"><span
                                                *ngFor="let category of resumeData?.categories;let i=index;">{{category?.jobPreferenceCategories?.name}}</span>
                                        </p>
                                    </div>
                                    <div class="col-lg-4 col-md-6 sol-sm-12 pd">
                                        <h6 class="heading-16">Sub-category</h6>
                                        <p class="para-16">
                                            <span class=""
                                                *ngFor="let subcategory of resumeData?.subCategory;let i=index; let isLast=last">
                                                <span *ngIf="i < 2">{{subcategory?.jobPreferenceSubCategories?.name}}
                                                    {{(i < 1 && !isLast) ? "," : "" }}</span>
                                                </span>
                                                <span class="orange viewAll"
                                                    (click)="openProjectDetail(subCategoryDetailPopup)"
                                                    *ngIf="resumeData?.subCategory.length > 2">View All</span>
                                        </p>
                                    </div>
                                    <div class="col-lg-4 col-md-6 sol-sm-12 pd">
                                        <h6 class="heading-16">Preferred Job title</h6>
                                        <!-- projectTile -->
                                        <p class="para-16"
                                            *ngIf="allJobPreference?.jobPreferenceJobTitleDetails != null">
                                            <span
                                                *ngFor="let jobName of allJobPreference?.jobPreferenceJobTitleDetails;let j=index;"
                                                class="relative">
                                                <span class="para-16 industryName"
                                                    *ngIf="j<2">{{jobName.JobTitleDetails?.name}}</span>
                                            </span>
                                            <span class="orange viewAll" (click)="openProjectDetail(projectTitleDetail)"
                                                *ngIf="allJobPreference?.jobPreferenceJobTitleDetails.length > 2">View
                                                All</span>
                                        </p>
                                        <p class="para-16"
                                            *ngIf="allJobPreference?.jobPreferenceJobTitleDetails == null">-</p>
                                    </div>
                                    <div class="col-lg-4 col-md-6 sol-sm-12 pd">
                                        <h6 class="heading-16">Desired salary</h6>
                                        <p class="para-16">{{allJobPreference?.desiredSalaryCurrency}}
                                            {{allJobPreference?.desiredSalary}}/{{allJobPreference?.desiredSalaryType}}
                                        </p>

                                    </div>
                                    <div class="col-lg-4 col-md-6 sol-sm-12 pd">
                                        <h6 class="heading-16">Service
                                            <!-- Military branch served -->
                                        </h6>
                                        <p class="para-16">{{allJobPreference?.serviceDetails?.name || "-"}}</p>

                                    </div>
                                    <!-- <div class="col-lg-4 col-md-6 sol-sm-12 pd">
                                        <h6 class="heading-16">Military job title</h6>
                                        <p class="para-16">{{allJobPreference?.serviceDetails?.name || "-"}}</p>

                                    </div> -->
                                    <div class="col-lg-4 col-md-6 sol-sm-12 pd">
                                        <h6 class="heading-16">Country served In</h6>
                                        <p class="para-16"
                                            *ngIf="allJobPreference?.jobPreferenceLocationDetails != null"><span
                                                *ngFor="let loc of allJobPreference?.jobPreferenceLocationDetails;let i=index;">{{loc.location}}</span>
                                        </p>
                                        <p class="para-16"
                                            *ngIf="allJobPreference?.jobPreferenceLocationDetails == null">-</p>

                                    </div>
                                    <div class="col-lg-4 col-md-6 sol-sm-12 pd">
                                        <!-- <h6 class="heading-16">Year served from</h6> -->
                                        <h6 class="heading-16">Date Of Availability</h6>
                                        <p class="para-16">{{(allJobPreference?.dateOfAvailability | date) || "-"}}</p>

                                    </div>
                                    <div class="col-lg-4 col-md-6 sol-sm-12 pd">
                                        <h6 class="heading-16">Preferred job Location</h6>
                                        <p class="para-16"
                                            *ngIf="allJobPreference?.jobPreferenceLocationDetails != null"><span
                                                *ngFor="let loc of allJobPreference?.jobPreferenceLocationDetails;let i=index;">{{loc.location}}</span>
                                        </p>
                                        <p class="para-16"
                                            *ngIf="allJobPreference?.jobPreferenceLocationDetails == null">-</p>

                                    </div>
                                    <div class="col-lg-4 col-md-6 sol-sm-12 pd">
                                        <h6 class="heading-16">Employment type</h6>
                                        <p class="para6"
                                            *ngIf="allJobPreference?.employmentTypeMultipleDetail != null">
                                            <span class="para-16 commoCss industryName"
                                                *ngFor="let emp of allJobPreference?.employmentTypeMultipleDetail; let isLast=last">
                                                {{emp?.name || '-'}}
                                            </span>
                                        </p>
                                        <p class="para-16"
                                            *ngIf="allJobPreference?.employmentTypeMultipleDetail == null">--</p>
                                    </div>
                                    <div class="col-lg-4 col-md-6 sol-sm-12 pd">
                                        <h6 class="heading-16">Travel requirements</h6>
                                        <p class="para-16"
                                            *ngIf="allJobPreference?.jobPreferenceTravelRequirementsDetails != null">
                                            <span class="para-16 industryName commoCss"
                                                *ngFor="let trav of allJobPreference?.jobPreferenceTravelRequirementsDetails;let i=index;">{{trav.travelRequirementsDetails?.name}}</span>
                                        </p>
                                        <p class="para-16"
                                            *ngIf="allJobPreference?.jobPreferenceTravelRequirementsDetails == null">-
                                        </p>

                                    </div>
                                    <div class="col-lg-4 col-md-6 sol-sm-12 pd">
                                        <h6 class="heading-16">Security clearance</h6>
                                        <p class="para-16" *ngIf="allJobPreference?.jobPreferenceSecurityClearanceDetails
                        != null"><span class="para-16 industryName" *ngFor="let sec of allJobPreference?.jobPreferenceSecurityClearanceDetails
                        ;let i=index;">{{sec.securityClearanceDetails?.name}}</span> </p>
                                        <p class="para-16" *ngIf="allJobPreference?.jobPreferenceSecurityClearanceDetails
                        == null">-</p>

                                    </div>
                                    <div class="col-lg-4 col-md-6 sol-sm-12 pd">
                                        <h6 class="heading-16">Preferred work type</h6>
                                        <p class="para-16 ">{{workShow(allJobPreference?.workPlace)}}</p>

                                    </div>
                                    <div class="col-lg-4 col-md-6 sol-sm-12 pd">
                                        <h6 class="heading-16">Willing to relocate</h6>
                                        <p class="para-16 ">{{allJobPreference?.willingToRelocate == 1 ? "Yes":"No"}}
                                        </p>

                                    </div>

                                    <div class="col-lg-4 col-md-6 sol-sm-12 pd">
                                        <h6 class="heading-16">Work Authorization</h6>
                                        <p class="para-16">
                                            <span *ngIf="allJobPreference?.workAuthorization == 0">No</span>
                                            <span *ngIf="allJobPreference?.workAuthorization == 1">Green card</span>
                                            <span *ngIf="allJobPreference?.workAuthorization == 2">EAD</span>
                                            <span *ngIf="allJobPreference?.workAuthorization == 3">H1B Visa</span>
                                            <span *ngIf="allJobPreference?.workAuthorization == 4">Citizen</span>
                                        </p>
                                    </div>
                                    <div class="col-lg-4 col-md-6 sol-sm-12 pd">
                                        <h6 class="heading-16">Service disabled?</h6>
                                        <p class="para-16 ">{{userData?.serviceDisabled == 1 ? "Yes":"No"}}</p>

                                    </div>
                                    <div class="col-lg-4 col-md-6 sol-sm-12 pd">
                                        <h6 class="heading-16">Are you vaccinated?</h6>
                                        <p class="para-16">{{allJobPreference?.covidVaccinated == 1 ? "Yes":"No"}}</p>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- end -->
        </div>
    </div><!--container end-->
</div>

<!-- project detail -->

<ng-template #projectTitleDetail>
    <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" (click)="closeModal()">&times;</button>
        <p class="para-16 align-left"><span
                *ngFor="let jobName of allJobPreference?.jobPreferenceJobTitleDetails;let i=index;"
                class="para-16 industryName"> {{jobName.JobTitleDetails?.name}}</span>
        </p>
    </div>
</ng-template>
<ng-template #subCategoryDetailPopup>
    <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" (click)="closeModal()">&times;</button>
        <p class="para-16">
            <span *ngFor="let subcategory of resumeData?.subCategory;let i=index; let isLast=last">
                {{subcategory?.jobPreferenceSubCategories?.name || "-"}}{{isLast ? "" : ", "}}
            </span>
        </p>
    </div>
</ng-template>
<!-- download -->
<ng-template #resume>
    <div class="modal-content addModal ">
        <div class="modal-body">
            <h4 class="pageTitle upper">Select template to download resume</h4>
            <p class="para text-left p-0 m-0">Your resume PDF will be downloaded in selected template</p>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeDownload()"><span
                    aria-hidden="true">&times;</span></button>
            <form [formGroup]="downloadForm" (ngSubmit)="onDownlaod()">
                <div class="row pb-2">
                    <div class="col-lg-4 col-md-4 col-sm-12" *ngFor="let temp of sampleList; let i =index;">
                        <div class="templatediv">
                            <div class="templateinner active">
                                <input type="radio" class="custom-checkbox" formControlName="templateSample"
                                    [value]="temp.templateId" [checked]="temp.templateId" id="radio1">
                                <input type="radio" class="custom-checkbox" formControlName="templateFormate"
                                    [value]="temp.templateFormate" [checked]="temp.templateFormate" readonly hidden>
                                <img [src]="temp.images != null ? globalTemplateUrl + temp.images :'assets/images/temp2.png'"
                                    for="radio1">
                                <img src="assets/images/ic_tick.svg" class="active2">
                            </div>
                            <p class="temptext">{{temp.name}}</p>
                        </div>
                    </div>
                </div>

                <div class="text-danger"
                    *ngIf="downloadForm.controls['templateSample'].hasError('required') && showTemplateError">
                    *Please Select atleast one template.
                </div>
                <input type="submit" class="commonBtn width50" value="Download" />
            </form>
        </div>
    </div>

</ng-template>
<!-- Edit Modal -->

<!-- profile -->
<ng-template #editProfile>
    <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalRef?.hide()"><span
                aria-hidden="true">×</span></button>
        <h4 class="pageTitle"> Edit Profile </h4>
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="personal-info">
                <div class="row">
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <div class="form-group">
                            <label> Phone Number1 </label>
                            <div class="countryCode">
                                <span><input type="text" class="form-control" formControlName="countryCode" readonly
                                        placeholder="(+1)"></span>
                                <input type="text" class="form-control" name="" placeholder=" 123-456-7890"
                                    formControlName="phoneNumber" (keypress)="preventNumbers($event)" appPhoneMask
                                    id="phone-number">
                            </div>
                            <div class="text-danger"
                                *ngIf="form.controls['phoneNumber'].hasError('required') && showError">
                                *Please enter phone number.
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-md-6 col-sm-12">
                        <div class="form-group">
                            <label> Location </label>
                            <input type="text" class="form-control" name="" placeholder=" Cr 92 No. 34E-112, Medellín "
                                formControlName="location">
                            <div class="text-danger"
                                *ngIf="form.controls['location'].hasError('required') && showError">
                                *Please enter location.
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12">
                        <div class="form-group">
                            <label> Score Link </label>
                            <input type="text" class="form-control" name="" placeholder="https://www.google.com"
                                formControlName="scoreLink">
                            <div class="text-danger"
                                *ngIf="form.controls['scoreLink'].hasError('required') && showError">
                                *Please enter score link.
                            </div>
                            <div class="text-danger"
                                *ngIf="form.controls['scoreLink'].hasError('pattern') && showError">
                                *Please enter Valid score link with https eg.(https://www.linkedin.com).
                            </div>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <input type="submit" class="commonBtn" value="Save">
                </div>
            </div>
        </form>
    </div>
</ng-template>

<!-- Veteran experience  -->
<ng-template #addVeteran>
    <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalRef?.hide()"><span
                aria-hidden="true">×</span></button>
        <h4 class="pageTitle">{{title}} Veteran Experience </h4>
        <form [formGroup]="formVeteran" (ngSubmit)="onSubmitDoc()">
            <div class="form-group">
                <div class="input-group custom-file-button">
                    <label class="input-group-text" for="uploadbanner" *ngIf="haveFileName == null">
                        {{userData.authenticityDocumentLink}} </label>
                    <label class="input-group-text" for="uploadbanner" *ngIf="haveFileName != null">
                        {{fileName}}
                        <input type="file" class="form-control" id="uploadbanner" #myInput (change)="uploadDoc($event)"
                            value="Upload Photo" accept=".jpg,.jpeg,.pdf">
                    </label>
                    <input type="file" class="form-control" id="uploadbanner" #myInput (change)="uploadDoc($event)"
                        value="Upload Photo" accept=".jpg,.jpeg,.pdf">
                </div>
                <p class="explain" [ngClass]="fileSize == true ? 'text-danger':''"> Max file size - 5mb & You should
                    only upload JPEG or PDF file. </p>
                <div class="text-danger" *ngIf="showError && haveFileName == null">
                    *Please Upload document.
                </div>
            </div>

            <div class="form-group" *ngIf="userData?.userType == 1">
                <div class="input-group custom-file-button">
                    <label class="input-group-text" for="uploadVeteranbanner"
                        *ngIf="haveVeternFileName == null">{{userData.veteranRelationDocumentLink}} </label>
                    <label class="input-group-text" for="uploadVeteranbanner"
                        *ngIf="haveVeternFileName != null">{{vetFileName}}<input type="file" class="form-control"
                            id="uploadVeteranbanner" #myInputDoc (change)="uploadVeteranDoc($event)"
                            value="Upload Photo" accept=".jpg,.jpeg,.pdf"></label>
                    <input type="file" class="form-control" id="uploadVeteranbanner" #myInputDoc
                        (change)="uploadVeteranDoc($event)" value="Upload Photo" accept=".jpg,.jpeg,.pdf">
                </div>
                <p class="explain" [ngClass]="fileSize == true ? 'text-danger':''"> Max file size - 5mb & You should
                    only upload JPEG or PDF file. </p>
                <div class="text-danger" *ngIf="showError && haveVeternFileName == ''">
                    *Please Upload document.
                </div>
            </div>
            <div class="form-group pb-4" *ngIf="userData?.userType == 1">
                <label>Spouse Name </label>
                <input type="text" class="form-control" placeholder="Please Enter Spouse Name"
                    formControlName="veteranRelationName" />
            </div>
            <div class="form-group pb-4">
                <label> Service </label>
                <div class="icon_div">
                    <select id="state" class="form-control" name="serviceId" formControlName="serviceId"
                        (ngModelChange)="selectedService($event)">
                        <option *ngFor="let data of serviceList;let i=index;" [value]="data.id">{{data.name}}</option>
                    </select>
                    <div class="text-danger"
                        *ngIf="formVeteran.controls['serviceId'].hasError('required') && showError">
                        *Please enter service.
                    </div>
                </div>
            </div>
            <div class="form-group pb-4" *ngIf="showOtherService">
                <label>Other Service Title<span class="orangeText">*</span> </label>
                <input type="text" class="form-control" placeholder="Other Service Title "
                    formControlName="otherServiceTitle" />
                <div class="text-danger"
                    *ngIf="showOtherService && formVeteran.value.otherServiceTitle == '' && showError">
                    *Please enter Other Service Title.
                </div>
            </div>
            <div class="form-group pb-4">
                <label> Military Job Title </label>
                <!-- <input type="text" class="form-control" name="militaryJobTitle"
                    placeholder="00H Enlisted Aide (Army - Enlisted) " formControlName="militaryJobTitle"
                    id="militaryJobTitle" maxlength="30" /> -->
                <ng-multiselect-dropdown formControlName="militaryTitle" class="form-control noBorder px-0 multiDrop"
                    [placeholder]="'Select'" [settings]="dropdownSettingsMilitary"
                    [data]="allMosCode"></ng-multiselect-dropdown>
                <div class="text-danger"
                    *ngIf="formVeteran.controls['militaryTitle'].hasError('required') && showError">
                    *Please enter military Job Title.
                </div>
                <div class="text-danger"
                    *ngIf="formVeteran.controls['militaryJobTitle'].hasError('required') && showError">
                    *Please enter military Job Title.
                </div>
            </div>

            <div class="form-group">
                <input type="submit" class="commonBtn" value="Continue">
            </div>
        </form>
    </div>
</ng-template>

<!-- skills -->
<ng-template #addSkill>
    <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalRef?.hide()"><span
                aria-hidden="true">×</span></button>
        <h4 class="pageTitle"> Skills </h4>
        <div class="form-group">
            <label> Skills <span class="orangeText">*</span> </label>
            <div class="skill">
                <input type="text" class="form-control" placeholder="Enter" [(ngModel)]="userSkill" name="userSkill"
                    id="userSkill" (ngModelChange)="searchSkill()" />
                <ul class="dropdown" *ngIf="show" (click)="dropSkill()">
                    <li *ngFor="let message of skillList;let i=index;" (click)="selectedSkill(i)">
                        <a href="javascript:void(0)">{{message.name}}</a>
                    </li>
                </ul>
            </div>
            <label class="small-highlights firstlCaptial"> You can add upto 50 skills </label>
            <div class="text-danger" *ngIf="skillform.controls['skillIdsArray'].hasError('required') && showError">
                *Please enter Skills.
            </div>
        </div>
        <form [formGroup]="skillform" (ngSubmit)="onSubmitSkill()">

            <div *ngIf="addedSkills.length > 0">
                <h5 class="subTitle"> Added skills </h5>
                <div class="form-group">
                    <ul class="addedskills">
                        <li *ngFor="let skill of addedSkills; let i=index;"> {{skill.name || skill.skillDetails.name}}
                            <a href="javascript:void(0);" (click)="removeSkills(i)"> × </a>
                        </li>
                    </ul>
                    <div class="text-danger" *ngIf="addedSkills.length > 50 && showError">
                        *You can add upto 50 skills only. Please remove additional skills.
                    </div>
                </div>
            </div>

            <div *ngIf="skillList.length > 0">
                <h5 class="subTitle"> Suggested skills </h5>
                <div class="form-group">
                    <ul class="suggestedskills">
                        <li *ngFor="let message of skillList;let i=index;" (click)="selectedSkill(i)">
                            {{message.name}}
                        </li>
                    </ul>
                </div>
            </div>

            <div class="form-group">
                <input type="submit" value="Continue" class="commonBtn width50 mt-4">
            </div>

        </form>
    </div>
</ng-template>
<!-- work exp -->
<ng-template #addMoreWork>
    <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalRef?.hide()"><span
                aria-hidden="true">×</span></button>
        <form [formGroup]="workForm" (ngSubmit)="onWorkSubmit()">
            <h4 class="pageTitle"> {{title}} Work Experience</h4>
            <div class="row">
                <div class="col-6">
                    <div class="form-group">
                        <label>Job title<span class="orangeText">*</span> </label>
                        <input type="text" name="" class="form-control upper" placeholder="Enter job"
                            formControlName="jobTitle" maxLength="50">
                        <div class="text-danger"
                            *ngIf="workForm.controls['jobTitle'].hasError('required') && showError">
                            *Please enter Job title.
                        </div>
                        <div class="text-danger"
                            *ngIf="workForm.controls['jobTitle'].hasError('maxLength') && showError">
                            *Maximum length of 50 characters.
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 ">
                    <div class="form-group">
                        <label> Company<span class="orangeText">*</span> </label>
                        <input type="text" name="" class="form-control upper" placeholder="Enter Company"
                            formControlName="companyName" maxLength="50">
                        <div class="text-danger"
                            *ngIf="workForm.controls['companyName'].hasError('required') && showError">
                            *Please enter company name.
                        </div>
                        <div class="text-danger"
                            *ngIf="workForm.controls['companyName'].hasError('maxLength') && showError">
                            *Maximum length of 50 characters.
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-lg-12 col-sm-12 ">
                    <h5 class="subTitle2 mb-0"> Employment type </h5>
                    <div class="form-group">
                        <ul class="suggestedskills">
                            <li *ngFor="let emp of allEmployee;let i=index;" (click)="selectedEmployment(i,$event)"
                                [ngClass]="emp.selected == true ? 'selected' : ''">{{emp.name}}</li>
                        </ul>
                        <div class="text-danger"
                            *ngIf="workForm.controls['employementTypeId'].hasError('required') && showError">
                            *Please enter employement type.
                        </div>
                    </div>
                </div>


                <div class="col-md-6 col-lg-6 col-sm-12" *ngIf="showContract">
                    <div class="form-group">
                        <label> Under contract of</label>
                        <input type="text" name="" class="form-control upper" placeholder="Infosys"
                            formControlName="underContractOf">
                        <div class="text-danger"
                            *ngIf="workForm.controls['underContractOf'].hasError('required') && showError">
                            *Please enter under contract of.
                        </div>
                    </div>
                </div>

                <div class="col-md-6 col-lg-6 col-sm-12 ">
                    <div class="form-group upperLetter">
                        <label> Location</label>
                        <input type="text" name="" class="form-control upper" placeholder="Columbia"
                            formControlName="location">
                        <div class="text-danger"
                            *ngIf="workForm.controls['location'].hasError('required') && showError">
                            *Please enter location.
                        </div>
                    </div>
                </div>

                <div class="col-md-6 col-lg-6 ">
                    <div class=" d-flex justify-content-between">
                        <div class="form-group">
                            <label> From </label>
                            <div id="date-picker-example" class="datepicker">
                                <input type="text" autocomplete="off" class="form-control" placeholder="Enter date"
                                    [bsValue]="workForm.value.fromDate" bsDatepicker placement="bottom"
                                    [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }"
                                    formControlName="fromDate" [maxDate]="maxDate">
                                <span class="ic_calendar"><img src="assets/images/ic_calendar.svg"></span>
                            </div>
                            <div class="text-danger"
                                *ngIf="showError == true && workForm.controls['fromDate'].hasError('required')">*Please
                                select From</div>
                        </div>

                        <div class="form-group">
                            <label> To </label>
                            <div id="date-picker-example" class="datepicker">
                                <input type="text" placeholder="Enter date" class="form-control" bsDatepicker
                                    [minDate]="workForm.value.fromDate == '' ? minDate : workForm.value.fromDate"
                                    formControlName="toDate" [bsValue]="workForm.value.toDate" [maxDate]="maxDate"
                                    [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }">
                                <span class="ic_calendar"><img src="assets/images/ic_calendar.svg"></span>
                            </div>
                            <div class="text-danger"
                                *ngIf="showError == true && workForm.controls['toDate'].hasError('required')">*Please
                                select To</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-lg-12  col-sm-12">
                    <div class="form-group">
                        <label> Description </label>
                        <textarea type="text" class="form-control"
                            placeholder="As a team lead, a UX manager sets design standards for the team and trains and supports the team in UX best practices."
                            formControlName="description" maxlength="250"></textarea>
                        <div class="text-danger"
                            *ngIf="workForm.controls['description'].hasError('required') && showError">
                            *Please enter description.
                        </div>
                        <div class="text-danger"
                            *ngIf="workForm.controls['description'].hasError('minlength') && showError">
                            *Minimum length of 3 characters.
                        </div>
                        <div class="text-danger"
                            *ngIf="workForm.controls['description'].hasError('maxlength') && showError">
                            *Minimum length of 250 characters.
                        </div>
                    </div>
                </div>

                <div class="col-md-6 col-lg-6 col-sm-12">
                    <div class="form-group pt-2">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="customCheckBox1"
                                formControlName="isCurrentlyRole" [value]="workForm.value.isCurrentlyRole"
                                [checked]="workForm.value.isCurrentlyRole"
                                (change)="workForm.value.isCurrentlyRole=1;isDisabled($event)">
                            <label class="custom-control-label" for="customCheckBox1"> I am currently working in this
                                role</label>
                            <div class="text-danger"
                                *ngIf="workForm.controls['isCurrentlyRole'].hasError('required') && showError">
                                *Please select I am currently working in this role.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group ">
                <input type="submit" value="Save" class="commonBtn width50 mt-4">
            </div>

        </form>
    </div>
</ng-template>
<!-- eductation -->
<ng-template #addMoreEdu>
    <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" (click)="modalRef?.hide();">&times;</button>
        <form [formGroup]="eduForm" (ngSubmit)="onEduSubmit()">
            <h4 class="pageTitle">{{title}} Education</h4>
            <div class="row">
                <div class="col-md-6 col-lg-6 ">
                    <div class="form-group">
                        <label> Degree or specialization<span class="orangeText">*</span> </label>
                        <select class="form-control" formControlName="specializationId"
                            (ngModelChange)="selectedDegree($event)">
                            <option disabled selected hidden> Please select</option>
                            <option *ngFor="let spec of allSpec;let i =index;" [value]="spec.id"> {{spec.name}}</option>
                        </select>
                        <div class="text-danger"
                            *ngIf="showError && eduForm.controls['specializationId'].hasError('required')">
                            *Please enter Degree or specialization.
                        </div>
                    </div>
                    <div class="form-group" *ngIf="showOtherDegree">
                        <label>Other Degree or Specialization<span class="orangeText">*</span> </label>
                        <input type="text" class="form-control" formControlName="otherTitleSpecialization">
                        <div class="text-danger"
                            *ngIf="showOtherDegree && eduForm.value.otherTitleSpecialization == '' && showError">
                            *Please enter othre Degree or specialization.
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 ">
                    <div class="form-group">
                        <label> University or institution<span class="orangeText">*</span> </label>
                        <select class="form-control" formControlName="universityId"
                            (ngModelChange)="selectedUniversity($event)">
                            <option disabled selected="selected" hidden> Please select</option>
                            <option *ngFor="let uni of allUni;let i =index;" [value]="uni.id"> {{uni.name}}</option>
                        </select>
                        <div class="text-danger"
                            *ngIf="eduForm.controls['universityId'].hasError('required') && showError">
                            *Please enter University or institution.
                        </div>
                    </div>

                    <div class="form-group" *ngIf="showOtherUniversity">
                        <label>Other University or institution<span class="orangeText">*</span> </label>
                        <input type="text" class="form-control" formControlName="otherTitleUniveristy">
                        <div class="text-danger"
                            *ngIf="eduForm.controls['otherTitleUniveristy'].hasError('required') && showError">
                            *Please enter othre University or institution.
                        </div>
                    </div>
                </div>

                <div class="col-md-6 col-lg-6 ">
                    <div class=" d-flex justify-content-between">
                        <div class="form-group">
                            <label> From </label>
                            <div id="date-picker-example" class="datepicker">
                                <input type="text" autocomplete="off" class="form-control" placeholder="Enter date"
                                    bsDatepicker placement="bottom" [bsValue]="eduForm.value.fromDate"
                                    [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }"
                                    formControlName="fromDate" [maxDate]="maxDate">
                                <span class="ic_calendar"><img src="assets/images/ic_calendar.svg"></span>
                            </div>
                            <div class="text-danger"
                                *ngIf="showError == true && eduForm.controls['fromDate'].hasError('required')">*Please
                                select From</div>
                        </div>

                        <div class="form-group">
                            <label> To </label>
                            <div id="date-picker-example" class="datepicker">
                                <input type="text" placeholder="Enter date" class="form-control" bsDatepicker
                                    [minDate]="eduForm.value.fromDate == '' ? minDate : eduForm.value.fromDate"
                                    formControlName="toDate" [bsValue]="eduForm.value.toDate" [maxDate]="maxDate"
                                    [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }">
                                <span class="ic_calendar"><img src="assets/images/ic_calendar.svg"></span>
                            </div>
                            <div class="text-danger"
                                *ngIf="showError == true && eduForm.controls['toDate'].hasError('required')">*Please
                                select To</div>
                        </div>
                    </div>
                </div>

                <div class="col-md-6 col-lg-6 ">
                    <div class="form-group">
                        <label>GPA </label>
                        <input type="text" name="" class="form-control" placeholder="4 GPA" formControlName="gpa"
                            (keypress)="preventNumbers($event)">
                        <div class="text-danger" *ngIf="eduForm.controls['gpa'].hasError('required') && showError">
                            *Please enter GPA.
                        </div>
                        <div class="text-danger" *ngIf="showGPAError">
                            *Please enter a value between 0 and 4.
                        </div>
                    </div>
                </div>

                <div class="col-md-12 col-lg-12 ">
                    <div class="form-group">
                        <label> Description </label>
                        <textarea type="text" class="form-control" placeholder="Enter description"
                            formControlName="description" maxlength="250"></textarea>
                        <div class="text-danger"
                            *ngIf="eduForm.controls['description'].hasError('required') && showError">
                            *Please enter description.
                        </div>
                        <div class="text-danger"
                            *ngIf="eduForm.controls['description'].hasError('minlength') && showError">
                            *Minimum length of 3 characters.
                        </div>
                        <div class="text-danger"
                            *ngIf="eduForm.controls['description'].hasError('maxlength') && showError">
                            *Minimum length of 250 characters.
                        </div>
                    </div>
                </div>

                <div class="col-md-12 col-lg-12">
                    <div class="form-group">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="customCheckBox1"
                                formControlName="isPursuing" [value]="1" [checked]="eduForm.value.isPursuing == 1"
                                (change)="eduForm.value.isPursuing = 1;isDisabled($event)">
                            <label class="custom-control-label" for="customCheckBox1"> I am currently pursuing this
                                course/degree </label>
                        </div>
                        <div class="text-danger"
                            *ngIf="eduForm.controls['isPursuing'].hasError('required') && showError">
                            *Please accept Conditions.
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <input type="submit" value="Save" class="commonBtn width50 mt-4">
            </div>

        </form>
    </div>
</ng-template>

<!-- volunteering -->
<ng-template #addMoreVol>
    <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"
                (click)="modalRef?.hide()">×</span></button>
        <form [formGroup]="volForm" (ngSubmit)="onVolSubmit()">
            <h4 class="pageTitle mb-2"> {{title}} Volunteer</h4>
            <div class="row">
                <div class="col-md-6 col-lg-6 ">
                    <div class="form-group">
                        <label>Organization<span class="orangeText">*</span> </label>
                        <input type="text" class="form-control" placeholder="Child care supervisor"
                            formControlName="organization" maxlength="50">
                        <div class="text-danger"
                            *ngIf="volForm.controls['organization'].hasError('required') && showError">
                            *Please enter organization.
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 ">
                    <div class="form-group">
                        <label> Role<span class="orangeText">*</span> </label>
                        <input type="text" class="form-control" placeholder="UX Manager" formControlName="role"
                            maxlength="50">
                        <div class="text-danger" *ngIf="volForm.controls['role'].hasError('required') && showError">
                            *Please enter role.
                        </div>
                    </div>
                </div>

                <div class="col-md-6 col-lg-6 ">
                    <div class="form-group">
                        <label>Cause</label>
                        <input type="text" class="form-control" placeholder="UX Manager" formControlName="cause">
                        <div class="text-danger" *ngIf="volForm.controls['cause'].hasError('required') && showError">
                            *Please enter cause.
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 ">
                    <div class=" d-flex justify-content-between">
                        <div class="form-group">
                            <label> From </label>
                            <div id="date-picker-example" class="datepicker">
                                <input type="text" autocomplete="off" class="form-control" placeholder="Enter date"
                                    [bsValue]="volForm.value.fromDate" bsDatepicker placement="bottom"
                                    [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }"
                                    formControlName="fromDate" [maxDate]="maxDate">
                                <span class="ic_calendar"><img src="../../../../assets/images/ic_calendar.svg"></span>
                            </div>
                            <div class="text-danger"
                                *ngIf="showError == true && volForm.controls['fromDate'].hasError('required')">*Please
                                select From</div>
                        </div>

                        <div class="form-group">
                            <label> To </label>
                            <div id="date-picker-example" class="datepicker">
                                <input type="text" placeholder="Enter date" class="form-control" bsDatepicker
                                    [minDate]="volForm.value.fromDate == '' ? minDate : volForm.value.fromDate"
                                    formControlName="toDate" [bsValue]="volForm.value.toDate" [maxDate]="maxDate"
                                    [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }">
                                <span class="ic_calendar"><img src="../../../../assets/images/ic_calendar.svg"></span>
                            </div>
                            <div class="text-danger"
                                *ngIf="showError == true && volForm.controls['toDate'].hasError('required')">*Please
                                select To</div>
                        </div>
                    </div>
                </div>



                <div class="col-md-12 col-lg-12  col-sm-12">
                    <div class="form-group">
                        <label> Description </label>
                        <textarea type="text" class="form-control"
                            placeholder="As a team lead, a UX manager sets design standards for the team and trains and supports the team in UX best practices."
                            formControlName="description" maxlength="250"></textarea>
                        <div class="text-danger"
                            *ngIf="volForm.controls['description'].hasError('required') && showError">
                            *Please enter description.
                        </div>
                        <div class="text-danger"
                            *ngIf="volForm.controls['description'].hasError('minlength') && showError">
                            *Minimum length of 3 characters.
                        </div>
                        <div class="text-danger"
                            *ngIf="volForm.controls['description'].hasError('maxlength') && showError">
                            *Minimum length of 250 characters.
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-lg-12 col-sm-12 ">
                    <h5 class="subTitle2">Employment type</h5>
                    <div class="form-group">
                        <ul class="suggestedskills">
                            <li *ngFor="let emp of allEmployee;let i=index;" (click)="selectedEmployment(i,$event)"
                                [ngClass]="emp.selected == true ? 'selected' : ''">{{emp.name}}</li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-12">
                    <div class="form-group mt-2">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="customCheckBox1"
                                formControlName="isCurrentlyRole" [value]="1"
                                [checked]="volForm.value.isCurrentlyRole == 1"
                                (change)="volForm.value.isCurrentlyRole=1;isDisabled($event)">
                            <label class="custom-control-label" for="customCheckBox1"> I am currently working in this
                                role</label>
                            <div class="text-danger"
                                *ngIf="volForm.controls['isCurrentlyRole'].hasError('required') && showError">
                                *Please accept select.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group ">
                <input type="submit" value="Save" class="commonBtn width50 mt-4">
            </div>
        </form>
    </div>
</ng-template>

<!-- awards -->
<ng-template #addMoreAward>
    <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" (click)="modalRef?.hide()">&times;</button>
        <form [formGroup]="awardform" (ngSubmit)="onAwardSubmit()">
            <h4 class="pageTitle">{{title}} Awards & Honors</h4>
            <div class="row">
                <div class="col-md-6 col-lg-6  col-sm-12">
                    <div class="form-group">
                        <label>Title <span class="orangeText">*</span> </label>
                        <input type="text" class="form-control upper" placeholder="Enter" formControlName="name"
                            maxlength="50">
                        <div class="text-danger" *ngIf="awardform.controls['name'].hasError('required') && showError">
                            *Please enter name.
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-12">
                    <div class="form-group">
                        <label>Associated with</label>
                        <input type="text" class="form-control upper" placeholder="Enter"
                            formControlName="associatedWith">
                        <div class="text-danger"
                            *ngIf="awardform.controls['associatedWith'].hasError('required') && showError">
                            *Please enter associated with.
                        </div>
                    </div>
                </div>


                <div class="col-md-6 col-lg-6 col-sm-12 ">
                    <div class="form-group">
                        <label>Issuer</label>
                        <input type="text" class="form-control upper" placeholder="Enter" formControlName="issuer">
                        <div class="text-danger" *ngIf="awardform.controls['issuer'].hasError('required') && showError">
                            *Please enter issuer.
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-12 ">
                    <div class="form-group">
                        <label> Issue date</label>
                        <div id="date-picker-example" class="datepicker">
                            <input type="text" autocomplete="off" class="form-control" placeholder="Enter date"
                                bsDatepicker placement="bottom" [bsValue]="awardform.value.issuesedOn"
                                [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }"
                                formControlName="issuesedOn" [maxDate]="maxDate">
                            <span class="ic_calendar"><img src="assets/images/ic_calendar.svg"></span>
                        </div>
                        <div class="text-danger"
                            *ngIf="showError == true && awardform.controls['issuesedOn'].hasError('required')">*Please
                            select Issue date</div>
                    </div>
                </div>

                <div class="col-md-12 col-lg-12  col-sm-12">
                    <div class="form-group">
                        <label>Description</label>
                        <textarea type="text" class="form-control"
                            placeholder="The bachelor of commerce (BCom) will provide you with a broad foundation knowledge of contemporary business and its practices."
                            formControlName="description" maxlength="250"></textarea>
                        <div class="text-danger"
                            *ngIf="awardform.controls['description'].hasError('required') && showError">
                            *Please enter description.
                        </div>
                        <div class="text-danger"
                            *ngIf="awardform.controls['description'].hasError('minlength') && showError">
                            *Minimum length of 3 characters.
                        </div>
                        <div class="text-danger"
                            *ngIf="awardform.controls['description'].hasError('maxlength') && showError">
                            *Minimum length of 250 characters.
                        </div>
                    </div>
                </div>

            </div>

            <div class="form-group ">
                <input type="submit" value="Save" class="commonBtn width50 mt-2">
            </div>

        </form>
    </div>
</ng-template>

<!-- projects -->
<ng-template #addMoreProjects>
    <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalRef?.hide()"><span
                aria-hidden="true">×</span></button>
        <form [formGroup]="projectForm" (ngSubmit)="onProjectSubmit()">
            <h4 class="pageTitle"> {{title}} Projects Undertaken</h4>
            <div class="row">
                <div class="col-md-6 col-lg-6 ">
                    <div class="form-group">
                        <label>Associated with</label>
                        <input type="text" class="form-control upper" placeholder="Child care supervisor"
                            formControlName="associatedWith">
                        <div class="text-danger"
                            *ngIf="projectForm.controls['associatedWith'].hasError('required') && showError">
                            *Please enter associated with.
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 ">
                    <div class="form-group">
                        <label> Preferred Job title <span class="orangeText">*</span> </label>
                        <input type="text" class="form-control upper" placeholder="Enter"
                            formControlName="projectTitle">
                        <div class="text-danger"
                            *ngIf="projectForm.controls['projectTitle'].hasError('required') && showError">
                            *Please enter preferred job title.
                        </div>
                        <div class="text-danger" *ngIf="projectForm.controls['projectTitle'].hasError('maxlength') && showError">
                            *Maximum length of 50 characters.
                        </div>
                    </div>
                </div>

                <div class="col-md-6 col-lg-6 col-sm-12 ">
                    <div class="form-group">
                        <label>Location</label>
                        <input type="text" class="form-control upper" placeholder="Enter" formControlName="location">
                        <div class="text-danger"
                            *ngIf="projectForm.controls['location'].hasError('required') && showError">
                            *Please enter location.
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-12 ">
                    <div class=" d-flex justify-content-between">
                        <div class="form-group">
                            <label> From </label>
                            <div id="date-picker-example" class="datepicker">
                                <input type="text" autocomplete="off" class="form-control" placeholder="Enter date"
                                    bsDatepicker placement="bottom" [bsValue]="projectForm.value.fromDate"
                                    [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }"
                                    formControlName="fromDate" [maxDate]="maxDate">
                                <span class="ic_calendar"><img src="../../../../assets/images/ic_calendar.svg"></span>
                            </div>
                            <div class="text-danger"
                                *ngIf="showError == true && projectForm.controls['fromDate'].hasError('required')">
                                *Please select From</div>
                        </div>

                        <div class="form-group">
                            <label> To </label>
                            <div id="date-picker-example" class="datepicker">
                                <input type="text" placeholder="Enter date" class="form-control" bsDatepicker
                                    [minDate]="projectForm.value.fromDate == '' ? minDate : projectForm.value.fromDate"
                                    [maxDate]="maxDate" formControlName="toDate" [bsValue]="projectForm.value.toDate"
                                    [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }">
                                <span class="ic_calendar"><img src="../../../../assets/images/ic_calendar.svg"></span>
                            </div>
                            <div class="text-danger"
                                *ngIf="showError == true && projectForm.controls['toDate'].hasError('required')">*Please
                                select To</div>
                        </div>
                    </div>
                </div>


                <div class="col-md-6 col-lg-6 col-sm-12">
                    <div class="form-group pt-2">
                        <div class="custom-control custom-checkbox">
                            <input type="checkbox" class="custom-control-input" id="customCheckBox1"
                                formControlName="isCurrentlyOngoing" [value]="1"
                                [checked]="projectForm.value.isCurrentlyOngoing == 1"
                                (change)="projectForm.value.isCurrentlyOngoing=1;isDisabled($event)">
                            <label class="custom-control-label" for="customCheckBox1"> I am currently working in this
                                role</label>
                            <div class="text-danger"
                                *ngIf="projectForm.controls['isCurrentlyOngoing'].hasError('required') && showError">
                                *Please accept select.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-lg-12  col-sm-12">
                    <h6 class="pageTitle subTitle2"> Team Members <a data-toggle="modal" data-target="#addModal"
                            data-dismiss="modal" class="addMoreBtn" (click)="openTeamModal(addMember)"> <i
                                class="pluseIcon"><img src="../../../../assets/images/ic_plus.svg"> </i> Add more member
                        </a></h6>
                </div>

                <div class="row addmemeber m-0 p-0">
                    <div class="col-lg-4 col-md-6 col-sm-12"
                        *ngFor="let data of projectForm.value.projectMembers; let i=index;">
                        <div class="form-group">
                            <div class="joinservice">
                                <div class="name">{{data.name}} <p class="email">{{data.email}}</p>
                                </div>
                                <div class="action">
                                    <a href="javascript:void(0);" (click)="editMember(i,addMember)" title="Edit"><img
                                            src="assets/images/ic_edit.svg" class="ht"> </a>
                                    <a href="javascript:void(0);" (click)="deleteMember(i)" title="Delete"><img
                                            src="assets/images/ic_delete.svg" class="ht"> </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-lg-12  col-sm-12">
                    <h5 class="subTitle2">Project Detail</h5>
                    <div class="form-group">
                        <label> Add project description</label>
                        <textarea type="text" class="form-control" placeholder="Write here"
                            formControlName="description" maxlength="250"></textarea>
                        <div class="text-danger"
                            *ngIf="projectForm.controls['description'].hasError('required') && showError">
                            *Please enter description.
                        </div>
                        <div class="text-danger"
                            *ngIf="projectForm.controls['description'].hasError('minlength') && showError">
                            *Minimum length of 3 characters.
                        </div>
                        <div class="text-danger"
                            *ngIf="projectForm.controls['description'].hasError('maxlength') && showError">
                            *Minimum length of 250 characters.
                        </div>
                    </div>
                </div>
                <div class="col-md-12 co-sm-12 col-lg-12 ">
                    <div class="form-group">
                        <label> Project Links </label>
                        <div class="p-relative">
                            <input type="text" class="form-control" placeholder="Enter" #hAwards
                                formControlName="projectLinksTypeOf">
                            <a href="javascript:void(0);" class="addMore" (click)="addHonors( hAwards.value)"
                                title="Add More"><img src="../../../../../../../../assets/images/add-circle.svg" /></a>
                        </div>
                        <div class="text-danger" *ngIf="showErrorToAdd">
                            *Please click on Plus icon to add project links.
                        </div>
                        <div class="text-danger" *ngIf="showLinkSameError">
                            *Please add different project links.
                        </div>
                        <div class="text-danger"
                            *ngIf="projectForm.controls['projectLinksTypeOf'].hasError('pattern') && showError">
                            *Please enter valid project link.
                        </div>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-lg-6 col-md-6 col-sm-12 mb-2" *ngFor="let awards of awardList;let i=index">
                            <div class="joinservice"> {{awards.link != null ? awards.link : awards.name}}<a
                                    href="javascript:void(0)" (click)="deleteHonors(awards)" title="Delete"><img
                                        src="../../../../assets/images/ic_delete.svg"> </a></div>
                        </div>
                    </div>
                </div>
                <div class="col-md-6 co-sm-12 col-lg-6">
                    <div class="form-group">
                        <label> Add project media </label>
                        <div class="imagesBox">
                            <div class="customfileupload">
                                <input type="file" id="myfile" name="myfile" accept=".png, .jpg, .jpeg" #myInput
                                    (change)="upload($event)">
                                <p><span><img src="../../../../assets/images/upload.svg"></span></p>
                            </div>
                            <div class="thumbnailIcon" *ngFor="let image of thumbnailImage; let i=index;">
                                <a href="javascript:void(0);" class="close" (click)="deleteImage(i)" title="Delete"><img
                                        src="../../../../assets/images/ic_close_image.svg"></a>
                                <img [src]="globalUrl + image.fileName" class="image" />
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="form-group ">
                <input type="submit" value="Save" class="commonBtn width50 mt-4">
            </div>

        </form>
    </div>
</ng-template>
<ng-template #addMember>
    <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalRef?.hide()"><span
                aria-hidden="true">&times;</span></button>
        <form [formGroup]="addTeam" (ngSubmit)="onAddTeam()">
            <h4 class="pageTitle mb-3"> {{title}} Team Members</h4>
            <div class="row">
                <div class="form-group  col-sm-6 col-md-6 col-lg-6">
                    <label> Full Name </label>
                    <input type="text" class="form-control" name="" placeholder="Enter" formControlName="name" />
                    <div class="text-danger"
                        *ngIf="addTeam.controls['name'].hasError('required') && showTeamMemberError">
                        *Please enter name.
                    </div>
                </div>

                <div class="form-group col-sm-6 col-md-6 col-lg-6">
                    <label> Email </label>
                    <input type="email" class="form-control" name="" placeholder="Enter" formControlName="email" />
                    <div class="text-danger"
                        *ngIf="addTeam.controls['email'].hasError('required') && showTeamMemberError">
                        *Please enter email.
                    </div>
                    <div class="text-danger"
                        *ngIf="addTeam.controls['email'].hasError('pattern') && showTeamMemberError">
                        *Invalid email. Please try again..
                    </div>
                </div>
            </div>
            <div class="form-group mt-2">
                <input type="submit" class="commonBtn width50" value="Save">
            </div>
        </form>
    </div>
</ng-template>

<!-- lic -->
<ng-template #addMoreLic>
    <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" (click)="modalRef?.hide();">&times;</button>
        <form [formGroup]="licForm" (ngSubmit)="onLicSubmit()">
            <h4 class="pageTitle">{{title}} Licenses / certifications</h4>
            <div class="row">
                <div class="col-md-6 col-lg-6  col-sm-12">
                    <div class="form-group">
                        <label>Name<span class="orangeText">*</span> </label>
                        <input type="text" class="form-control upper" placeholder="Behavioural economics"
                            formControlName="name">
                        <div class="text-danger" *ngIf="licForm.controls['name'].hasError('required') && showError">
                            *Please enter name.
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-12">
                    <div class="form-group">
                        <label>Attested by authority <span class="orangeText">*</span> </label>
                        <input type="text" class="form-control upper" placeholder="Ogilvy consulting USA"
                            formControlName="attestedByAuthority">
                        <div class="text-danger"
                            *ngIf="licForm.controls['attestedByAuthority'].hasError('required') && showError">
                            *Please enter attested by authority.
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-12 ">
                    <div class="form-group">
                        <label>ID/Certificate No.</label>
                        <input type="text" class="form-control" placeholder="Certificate Id - 304304"
                            formControlName="certificationNo" maxlength="60">
                        <div class="text-danger"
                            *ngIf="licForm.controls['certificationNo'].hasError('required') && showError">
                            *Please enter ID Certificate No.
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-12 ">
                    <div class=" d-flex justify-content-between">
                        <div class="form-group">
                            <label> Issue date</label>
                            <div id="date-picker-example" class="datepicker">
                                <input type="text" autocomplete="off" class="form-control" placeholder="Enter date"
                                    bsDatepicker placement="bottom" [bsValue]="licForm.value.issuesedOn"
                                    [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }"
                                    formControlName="issuesedOn" [maxDate]="maxDate"
                                    (bsValueChange)="onDateChange($event)">
                                <span class="ic_calendar"><img src="assets/images/ic_calendar.svg"></span>
                            </div>
                            <div class="text-danger"
                                *ngIf="showError == true && licForm.controls['issuesedOn'].hasError('required')">*Please
                                enter Issue date</div>
                        </div>
                        <div class="form-group">
                            <label>Expiry date (If any)</label>
                            <div id="date-picker-example" class="datepicker">
                                <input type="text" placeholder="Enter date" class="form-control" bsDatepicker
                                    [minDate]="licForm.value.issuesedOn == '' ? minDate : licForm.value.issuesedOn"
                                    formControlName="expirydate"
                                    [minDate]="licForm.value.issuesedOn == '' ? minDate : licForm.value.issuesedOn"
                                    [bsValue]="licForm.value.expirydate"
                                    [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }">
                                <span class="ic_calendar"><img src="assets/images/ic_calendar.svg"></span>
                            </div>
                            <div class="text-danger"
                                *ngIf="showError == true && licForm.controls['expirydate'].hasError('required')">*Please
                                enter expiry date</div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12 co-sm-12 col-lg-12 ">
                    <div class="form-group">
                        <label> Certified URL </label>
                        <input type="text" class="form-control" placeholder="www.splashdesignstudio.com"
                            formControlName="credentialUrl">
                        <div class="text-danger"
                            *ngIf="licForm.controls['credentialUrl'].hasError('required') && showError">
                            *Please enter Certified URL.
                        </div>
                        <div class="text-danger"
                            *ngIf="licForm.controls['credentialUrl'].hasError('pattern') && showError">
                            *Please enter Valid Certified URL with https or http.
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group ">
                <input type="submit" value="Save" class="commonBtn width50 mt-2">
            </div>

        </form>
    </div>
</ng-template>

<!-- language -->
<ng-template #addMoreLang>
    <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"
                (click)="modalRef?.hide()">×</span></button>
        <form [formGroup]="langForm" (ngSubmit)="onLangSubmit()">
            <h4 class="pageTitle mb-2">{{title}} Languages </h4>
            <div class="row">
                <div class="col-md-6 col-lg-6  col-sm-12">
                    <div class="form-group">
                        <label>Language<span class="orangeText">*</span> </label>
                        <!-- <input type="text" class="form-control" placeholder="Spanish" formControlName="language"> -->
                        <ng-multiselect-dropdown formControlName="language" class="form-control noBorder px-0"
                            [placeholder]="'Select'" [settings]="dropdownLanguageSettings"
                            [data]="Languages"></ng-multiselect-dropdown>
                        <div class="text-danger"
                            *ngIf="langForm.controls['language'].hasError('required') && showError">
                            *Please enter language.
                        </div>

                        <div class="text-danger" *ngIf="showErrorSameLanguage">
                            *Please enter different language.
                        </div>
                    </div>
                </div>

                <div class="col-md-6 col-lg-6 col-sm-12 ">
                    <div class="form-group">
                        <label>Proficiency<span class="orangeText">*</span> </label>
                        <select class="form-control" placeholder="Select Proficiency" formControlName="proficiency">
                            <option value="Read">Read</option>
                            <option value="WriteRead">Write and read</option>
                            <option value="Speak">Speak</option>
                            <option value="NativeBilingual">Native or bilingual</option>
                        </select>
                        <div class="text-danger"
                            *ngIf="langForm.controls['proficiency'].hasError('required') && showError">
                            *Please enter proficiency.
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group">
                <input type="submit" value="Save" class="commonBtn width50 mt-2">
            </div>
        </form>
    </div>
</ng-template>

<!-- Edit Modal -->

<ng-template #jobPref>
    <div class="modal-body edit">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true"
                (click)="closeModel()">×</span></button>
        <form [formGroup]="jobForm" (ngSubmit)="onJobSubmit()">
            <div class="topHeader">
                <h5 class="modal-title text-left"> Edit Job Preferences </h5>
            </div>
            <div class="row">
                <div class="col-md-12 col-lg-12 col-sm-12">
                    <div class="form-group">
                        <label>Preferred industry <span class="orangeText">*</span></label>
                        <div class="search">
                            <!-- <input type="text" class="form-control select" placeholder="Enter" [(ngModel)]="userIndus"
                                name="userIndus" id="userInduss" (ngModelChange)="searchIndus()"
                                formControlName="industrySearch" autocomplete="off" />
                            <ul class="dropdown" *ngIf="showIndus">
                                <li *ngFor="let indus of allIndustry;let i=index;"
                                    (click)="selectedIndus(i);dropIndus()">
                                    <a href="javascript:void(0)">{{indus.name}}</a>
                                </li>
                            </ul> -->
                            <ng-multiselect-dropdown formControlName="industryIds" class="form-control noBorder px-0"
                                [placeholder]="'Select'" [settings]="dropdownSettingsIndustry"
                                [data]="allIndustry"></ng-multiselect-dropdown>
                        </div>
                        <div class="text-danger"
                            *ngIf="jobForm.controls['industryIds'].hasError('required') && showError">
                            *Please enter Preferred industry.
                        </div>
                        <!-- <ul class="addedskills mt-3">
                            <li *ngFor="let indus of addedIndus; let i=index;"> {{indus.name}} <a
                                    href="javascript:void(0);" (click)="removeIndus(i)"> × </a> </li>
                        </ul> -->
                    </div>

                    <div class="form-group">
                        <label>Select category <span class="orangeText">*</span></label>
                        <select class="form-control" formControlName="categoryId" (change)="selectCategoryId($event)">
                            <option disabled selected>Enter</option>
                            <option *ngFor="let cat of allCat;let i=index" [value]="cat.id">{{cat.name}}</option>
                        </select>
                        <div class="text-danger"
                            *ngIf="jobForm.controls['categoryId'].hasError('required') && showError">
                            *Please select category.
                        </div>
                    </div>

                    <div class="form-group" *ngIf="subCat">
                        <label>Sub category </label>
                        <ng-multiselect-dropdown formControlName="subCategoryId"
                            class="form-control noBorder px-0 subCatMulti" [placeholder]="'Select'"
                            [settings]="dropdownSettings" [data]="allSubCat"
                            [ngClass]="allSubCat.length == 0 ?'disabled':''"></ng-multiselect-dropdown>
                        <div class="text-danger"
                            *ngIf="jobForm.controls['subCategoryId'].hasError('required') && showError">
                            *Please select sub category.
                        </div>
                    </div>
                    <div class="form-group">
                        <label>Preferred Job title <span class="orangeText">*</span></label>
                        <div class="search">
                            <!-- <input type="text" class="form-control select" placeholder="Enter" [(ngModel)]="jobQues"
                                name="jobQues" id="jobQues" (ngModelChange)="searchJob()"
                                formControlName="industrySearch" autocomplete="off" />
                            <ul class="dropdown" *ngIf="showJob">
                                <li *ngFor="let job of allJobtitle;let i=index;" (click)="selectedJobs(i);dropJob()">
                                    <a href="javascript:void(0)">{{job.name}}</a>
                                </li>
                            </ul> -->
                            <ng-multiselect-dropdown formControlName="jobTitleIds" class="form-control noBorder px-0"
                                [placeholder]="'Select'" [settings]="dropdownSettingJobTitle"
                                [data]="allJobtitle"></ng-multiselect-dropdown>
                        </div>
                        <div class="text-danger"
                            *ngIf="jobForm.controls['jobTitleIds'].hasError('required') && showError">
                            *Please enter Preferred job title.
                        </div>
                        <div class="text-danger" *ngIf="jobForm.value.jobTitleIds?.length>50 && !jobForm.controls['jobTitleIds'].hasError('required')">
                            *You can add up to 50 Preferred job title. Please remove additional Preferred job title.
                        </div>

                        <!-- <ul class="addedskills mt-3">
                            <li *ngFor="let job of addedJobs; let i=index;"
                                [ngClass]="job.selected == true ? 'selected' : ''"> {{job.name}} <a
                                    href="javascript:void(0);" (click)="removeJob(i)"> × </a> </li>
                        </ul> -->
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-12 ">
                    <div class="form-group">
                        <label>Service</label>
                        <select id="state" class="form-control" name="serviceId" formControlName="serviceId"
                            (ngModelChange)="selectedService($event)">
                            <option *ngFor="let data of serviceList;let i=index;" [value]="data.id">{{data.name}}
                            </option>
                        </select>
                        <div class="text-danger"
                            *ngIf="jobForm.controls['serviceId'].hasError('required') && showError">
                            *Please enter service.
                        </div>
                    </div>
                </div>

                <div class="col-md-6 col-lg-6 col-sm-12" *ngIf="showOtherService">
                    <div class="form-group">
                        <label>Other Service Title<span class="orangeText">*</span> </label>
                        <input type="text" class="form-control" placeholder="Other Service Title "
                            formControlName="otherServiceTitle" />
                        <div class="text-danger"
                            *ngIf="showOtherService && form.controls['dateOfAvailability'].hasError('otherServiceTitle') && showError">
                            *Please enter Other Service Title.
                        </div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-12 ">
                    <div class="form-group">
                        <label>Date of availability</label>
                        <div id="date-picker-example" class="datepicker">
                            <input type="text" autocomplete="off" class="form-control" placeholder="Enter date"
                                bsDatepicker placement="bottom" [bsValue]="jobForm.value.dateOfAvailability"
                                [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }"
                                [minDate]="minDate" formControlName="dateOfAvailability">
                            <span class="ic_calendar"><img src="assets/images/ic_calendar.svg"></span>
                        </div>
                        <div class="text-danger"
                            *ngIf="showError == true && (jobForm.controls['dateOfAvailability'].hasError('required') || jobForm.value.dateOfAvailability < currentDate)">
                            *Date of availability cannot be past date.</div>
                    </div>
                </div>

                <div class="col-md-6 col-lg-6 col-sm-12 ">

                    <div class="form-group">
                        <label>Desired Salary </label>
                        <div class=" d-flex justify-content-between salaryDiv">
                            <input type="text" class="form-control" placeholder="USD" value="USD" readonly>
                            <input type="text" class="form-control" placeholder="Enter" formControlName="desiredSalary"
                                (keypress)="preventNumbers($event)" maxlength="10">
                            <select class="form-control" formControlName="desiredSalaryType">
                                <option value="Per Hour">Per Hour</option>
                                <option value="Per Day">Per Day</option>
                                <option value="Per Week">Per Week</option>
                                <option value="Per Month">Per Month</option>
                                <option value="Per Annum">Per Annum</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12 col-lg-12 col-sm-12">
                    <h6 class="pageTitle subTitle2">Tour of Duty
                        <a data-toggle="modal" data-target="#addModal" data-dismiss="modal" class="addMoreBtn"
                            (click)="openTourDuty(addTourDuty)"> <i class="pluseIcon"><img
                                    src="assets/images/ic_plus.svg"> </i> Add more</a>
                    </h6>
                </div>

                <div class="col-sm-12 col-md-6 col-lg-6" *ngFor="let tour of jobForm.value.tourOfDuties;let i=index;">
                    <div class="joinservice">
                        <div class="textinner">{{tour.location}}
                            <p class="para3">Served from : {{tour.fromDate | date}} - {{tour.toDate |date}}</p>
                        </div>
                        <div>
                            <a href="javascript:void(0)" (click)="editTour(i,addTourDuty)" title="Edit"><img
                                    src="assets/images/ic_edit.svg" class="ht"> </a>
                            <a href="javascript:void(0)" (click)="deleteTour(i)" title="Delete"><img
                                    src="assets/images/ic_delete.svg" class="ht"></a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row  ptb">
                <div class="col-md-12 col-lg-12 col-sm-12">
                    <h6 class="pageTitle subTitle2"><label>Preferred Job Location <span class="orangeText">*</span>
                        </label>
                        <a data-toggle="modal" data-target="#addModal" data-dismiss="modal" class="addMoreBtn"
                            (click)="openPreferredLocation(addJobs)"> <i class="pluseIcon"><img
                                    src="assets/images/ic_plus.svg"> </i> Add more</a>
                    </h6>
                </div>

                <div class="col-sm-12 col-md-6 col-lg-6" *ngFor="let loc of jobForm.value.locations;let i=index;">
                    <div class="joinservice"> {{loc.location}}
                        <div>
                            <a href="javascript:void(0)" (click)="editLocation(loc,i,addJobs)" title="Edit"><img
                                    src="assets/images/ic_edit.svg" class="ht"> </a>
                            <a href="javascript:void(0)" (click)="deleteLocation(i)" title="Delete"><img
                                    src="assets/images/ic_delete.svg" class="ht"></a>
                        </div>
                    </div>
                </div>

                <div class="text-danger" *ngIf="jobForm.controls['locations'].hasError('required') && showError">
                    *Please add Preferred Job Location</div>
                <!-- <div class="text-danger" *ngIf="showLocError == true">
                    *Please add Preferred Job Location</div> -->
            </div>
            <div class="row">

                <div class="col-lg-12 col-md-12 col-sm-12">
                    <div class="form-group">
                        <label>Work Authorization<span class="orangeText">*</span></label>
                        <select class="form-control" formControlName="workAuthorization">
                            <option value="0">No</option>
                            <option value="1">Green card</option>
                            <option value="2">EAD</option>
                            <option value="3">H1B Visa</option>
                            <option value="4">Citizen</option>
                        </select>
                        <div class="text-danger"
                            *ngIf="jobForm.controls['workAuthorization'].hasError('required') && showError">
                            *Please enter work authorization.
                        </div>
                    </div>
                </div>
                <div class="col-md-12 col-lg-12 col-sm-12 ">
                    <h5 class="subTitle">Employment type</h5>
                    <div class="form-group">
                        <ul class="suggestedskills">
                            <li *ngFor="let emp of allEmployee;let i=index;" (click)="selectedEmploymentType(i,$event)"
                                [ngClass]="emp.selected == true ? 'selected' : ''">{{emp.name}}</li>
                        </ul>
                    </div>
                </div>

                <div class="col-md-12 col-lg-12 col-sm-12 ">
                    <h5 class="subTitle">Work Place</h5>
                    <div class="form-group">
                        <ul class="suggestedskills">
                            <li *ngFor="let emp of workPlaceList;let i=index;" (click)="selectedworkPlaceList(i,$event)"
                                [ngClass]="emp.selected == true ? 'selected' : ''">{{emp.name}}</li>
                        </ul>
                         <!-- <ul class="suggestedskills radioBox_set">
                            <li>
                                <label class="radioSwitch-label" for="workType"> <input type="radio" id="workType"
                                        [value]="'Remote'" formControlName="workPlace" name="workPlace"
                                        (change)="jobForm.value.workPlace='Remote'"
                                        [checked]="jobForm.value.workPlace=='Remote'"><i
                                        class="input-helper"></i><span>Remote</span> </label>
                            </li>
                            <li>
                                <label class="radioSwitch-label" for="workType">
                                    <input type="radio" id="workType" [value]="'Onsite'" formControlName="workPlace"
                                        name="workPlace" (change)="jobForm.value.workPlace='Onsite'"
                                        [checked]="jobForm.value.workPlace=='Onsite'"><i
                                        class="input-helper"></i><span>Onsite</span></label>
                            </li>
                            <li>
                                <label class="radioSwitch-label" for="workType">
                                    <input type="radio" id="workType" [value]="'Hybrid'" formControlName="workPlace"
                                        name="workPlace" (change)="jobForm.value.workPlace='Hybrid'"
                                        [checked]="jobForm.value.workPlace=='Hybrid'"><i
                                        class="input-helper"></i><span>Hybrid</span></label>
                            </li>
                        </ul>  -->
                    </div>
                </div>

                <div class="col-md-12 col-lg-12 col-sm-12 ">
                    <h5 class="subTitle">Travel requirements</h5>
                    <div class="form-group">
                        <ul class="suggestedskills">
                            <li *ngFor="let trav of allTravel;let i=index;" (click)="selectedTravel(i,$event)"
                                [ngClass]="trav.selected == true ? 'selected' : ''">{{trav.name}}</li>
                        </ul>
                    </div>
                </div>

                <div class="col-md-12 col-lg-12 col-sm-12 ">
                    <h5 class="subTitle">Security clearance</h5>
                    <div class="form-group">
                        <ul class="suggestedskills">
                            <li *ngFor="let sec of allSecurity;let i=index;" (click)="selectedSecurity(i,$event)"
                                [ngClass]="sec.selected == true ? 'selected' : ''">{{sec.name}}</li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="form-group">
                        <label>Are you willing to relocate ?</label>
                        <div class="d-flex spaceRight radioWrap">
                            <input type="radio" id="yes" [value]="1" formControlName="willingToRelocate">
                            <label for="yes"> Yes </label>
                            <input type="radio" id="no" [value]="0" formControlName="willingToRelocate">
                            <label for="no"> No </label>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="form-group">
                        <label>Are you covid-19 vaccinated ?</label>
                        <div class="d-flex spaceRight radioWrap">
                            <input type="radio" id="yes1" [value]="1" formControlName="covidVaccinated">
                            <label for="yes1"> Yes </label>
                            <input type="radio" id="no1" [value]="0" formControlName="covidVaccinated">
                            <label for="no1"> No </label>
                        </div>
                    </div>
                </div>

                <div class="form-group col-md-12 co-sm-12 col-lg-12">
                    <input type="submit" value="Save" class="commonBtn width50 mt-2">
                </div>
            </div>
        </form>
    </div>
</ng-template>


<!-- Modals  -->
<ng-template #addTourDuty>
    <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close"
            (click)="this.modalRef?.hide()"><span aria-hidden="true">&times;</span></button>
        <form [formGroup]="addTour" (ngSubmit)="onTourDuty()">
            <h4 class="pageTitle mb-3"> Tour of Duty</h4>
            <div class="row">
                <div class="col-md-6 col-lg-6  col-sm-12">
                    <div class="form-group">
                        <label>Location<span class="orangeText">*</span> </label>
                        <input type="text" class="form-control" placeholder="Enter location" formControlName="location">
                        <div class="text-danger"
                            *ngIf="showError == true && addTour.controls['location'].hasError('required')">*Please
                            select location</div>
                    </div>
                </div>

                <div class="col-md-6 col-lg-6 col-sm-12 ">
                    <div class="form-group">
                        <label>Zip Code<span class="orangeText">*</span> </label>
                        <input type="text" class="form-control" placeholder="Enter zip code" formControlName="zipCode"
                            (keypress)="preventNumbers($event)" maxlength="6">
                        <div class="text-danger"
                            *ngIf="showError == true && addTour.controls['zipCode'].hasError('required')">*Please select
                            zip code</div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-12 ">
                    <div class="form-group">
                        <label> From </label>
                        <div id="date-picker-example" class="datepicker">
                            <input type="text" autocomplete="off" class="form-control" placeholder="Enter date"
                                bsDatepicker placement="bottom" [bsValue]="addTour.value.fromDate"
                                [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }"
                                formControlName="fromDate" [maxDate]="maxDate">
                            <span class="ic_calendar"><img src="assets/images/ic_calendar.svg"></span>
                        </div>
                        <div class="text-danger"
                            *ngIf="showError == true && addTour.controls['fromDate'].hasError('required')">*Please
                            select From</div>
                    </div>
                </div>
                <div class="col-md-6 col-lg-6 col-sm-12 ">
                    <div class="form-group">
                        <label> To </label>
                        <div id="date-picker-example" class="datepicker">
                            <input type="text" placeholder="Enter date" class="form-control" bsDatepicker
                                [minDate]="addTour.value.fromDate == '' ? minDate : addTour.value.fromDate"
                                formControlName="toDate" [bsValue]="addTour.value.toDate"
                                [bsConfig]="{ isAnimated: true, dateInputFormat: 'DD-MM-YYYY',showWeekNumbers: false,showTodayButton: true }">
                            <span class="ic_calendar"><img src="assets/images/ic_calendar.svg"></span>
                        </div>
                        <div class="text-danger"
                            *ngIf="showError == true && addTour.controls['toDate'].hasError('required')">*Please select
                            To</div>
                    </div>
                </div>
            </div>
            <div class="form-group mt-2">
                <input type="submit" class="commonBtn width50" value="Save" />
            </div>
        </form>
    </div>
</ng-template>
<!-- Modals  -->
<ng-template #addJobs>
    <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalRef?.hide()"><span
                aria-hidden="true">&times;</span></button>
        <form [formGroup]="addJob" (ngSubmit)="onAddJobs()">
            <h4 class="PageTitle mb-3">{{title}} Preferred Job Location</h4>
            <div class="row">
                <div class="col-md-6 col-lg-6  col-sm-12">
                    <div class="form-group">
                        <label>Location<span class="orangeText">*</span> </label>
                        <input type="text" class="form-control" placeholder="Enter location" formControlName="location">
                        <!-- <div class="text-danger"
                            *ngIf="addJob.controls['location'].hasError('required') && showLocationError">
                            *Please enter location.
                        </div> -->
                    </div>
                </div>

                <div class="col-md-6 col-lg-6 col-sm-12 ">
                    <div class="form-group">
                        <label>Zip Code<span class="orangeText">*</span> </label>
                        <input type="text" class="form-control" placeholder="Enter zip code" formControlName="zipCode"
                            (keypress)="preventNumbers($event)" maxlength="6">
                        <div class="text-danger"
                            *ngIf="(addJob.controls['zipCode'].hasError('required') && addJob.value.zipCode == '' ) && showLocationError">
                            *Please enter zip code.
                        </div>
                        <div class="text-danger" *ngIf="addJob.value.zipCode != '' && showLocationError ">
                            *Please enter valid zipcode.
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group mt-2">
                <input type="submit" class="commonBtn width50" value="Save">
            </div>
        </form>
    </div>
</ng-template>